import * as Ink from "inkjs"
import LocalStorage from "local-storage-json"
import Dev from "@frog/source/models/admin/Dev.js"
import Navigation from "@frog/source/models/admin/Navigation.js"

// TODO: don't hardcode this to a single game, have
// this be passed in when calling for ink dialogue
import STORY from "@frog/source/data/games/pirates/script.ink.json"

export default new class {
    constructor() {
        if(Dev.isEnabled == true
        && LocalStorage.get("ink") != undefined) {
            this.story = new Ink.Story(LocalStorage.get("ink"))
            console.log("%cInk: We are using a locally uploaded script. To drop this script, run ink.wipe()", "color: green")
            // document.documentElement.style.backgroundColor = "hotpink"
        } else {
            this.story = new Ink.Story(STORY)
        }

        window.ink = {
            "wipe": function() {
                LocalStorage.remove("ink")
                window.location.reload()
            },
            "reset": () => {
                this.loadDialogue("reset_run")
            },
            "endgame": () => {
                this.loadDialogue("endgame")
            }
        }
        this.story.onError = function(error) {
            console.error(error)
        }
    }
    loadDialogue(knotname) {
        try {
            this.story.ChoosePathString(knotname)
            return this.loadNextDialogue()
        } catch(error) {
            // console.log(error)
            // console.log("Could not find narrative trigger: " + knotname)
            return []
        }
    }
    loadNextDialogue() {
        const dialogues = []

        while(this.story.canContinue) {
            const dialogue = {}
            dialogue.data = {}

            // WORDS //
            let words = this.story.Continue()

            words = words.split(" ").map((word) => word.trim())
            if(words[0].endsWith(":")) {
                dialogue.speakingCharacter = words[0].slice(0, -1).toLowerCase()
                dialogue.data.unitKey = words[0].slice(0, -1).toLowerCase()
                dialogue.data.speakerName = words[0].slice(0, -1)
                words.shift()
            }
            words = words.join(" ")

            if(words != "" && words != "\n") {
                dialogue.text = words
            }

            // TAGS //
            dialogue.tags = {}
            this.story.currentTags.forEach((tag) => {
                if(tag.includes("=")) {
                    const key = tag.split("=")[0]
                    const value = tag.split("=")[1]
                    dialogue.tags[key] = value
                } else {
                    dialogue.tags["_"] = tag
                }
            })

            // // CHOICES //
            // if(this.story.currentChoices != undefined
            // && this.story.currentChoices.length > 0) {
            //     dialogue.choices = this.story.currentChoices.map(function(choice) {
            //         return {
            //             "text": choice.text,
            //             "function": function() {
            //                 this.story.ChooseChoiceIndex(choice.index)
            //                 const nextDialogues = this.loadNextDialogue()
            //                 // TODO: Load these up next!!
            //             }
            //         }
            //     })
            // }

            dialogues.push(dialogue)
        }

        return dialogues
    }
    set(key, value) {
        try {
            this.story.variablesState[key] = value
        } catch(error) {
            console.log(error)
            console.log("Could not find state variable: " + key)
            return []
        }
    }
    increment(key, value) {
        if(value === undefined) {
            value = 1
        }
        try {
            this.story.variablesState[key] = this.story.variablesState[key] || 0
            this.story.variablesState[key] = this.story.variablesState[key] + 1
            console.log(this.story.variablesState[key])
        } catch(error) {
            console.log(error)
            console.log("Could not find state variable: " + key)
            return []
        }
    }
}

// story.BindExternalFunction("unlock", (key) => {
//     console.log("UNLOCKING", key)
// })

// function showAfter(delay, el, text, style = "color: #000") {
//     setTimeout(function() { console.log("%c " + text, style) }, delay)
//     // setTimeout(function() { el.classList.add("show") }, delay)
// }

////////////////////
// Ink Dev Tools //
//////////////////

if(Dev.isEnabled == true && false) {
    document.getElementById("dev").addEventListener("dragenter", function(event) {
        document.getElementById("dev").setAttribute("juiced", true)
    })

    document.getElementById("dev").addEventListener("dragleave", function(event) {
        document.getElementById("dev").setAttribute("juiced", false)
    })

    document.getElementById("dev").addEventListener("dragover", function(event) {
        event.stopPropagation()
        event.preventDefault()
    })

    document.getElementById("dev").addEventListener("contextmenu", function(event) {
        event.stopPropagation()
        event.preventDefault()
    })

    document.getElementById("dev").addEventListener("drop", function(event) {
        event.stopPropagation()
        event.preventDefault()

        document.getElementById("dev").setAttribute("juiced", false)

        const files = event.dataTransfer.files
        Array.from(files).forEach((file) => {
            if(file.type.match("application/json") == false) {
                return
            }
            const reader = new FileReader()
            reader.addEventListener("load", function(event) {
                try {
                    const json = JSON.parse(event.target.result)
                    LocalStorage.set("ink", json)
                    window.location.reload()

                } catch(error) {
                    console.error("Failed to parse the file as JSON:", error)
                }
            })
            reader.readAsText(file)
        })
    })
}
